var Tools = require('../../deploynaut/js/tools.jsx');
var Configuration = require('./Configuration.jsx');

Tools.install(Configuration, 'Configuration');
